export const language = {
  zh: {
    'Company Management': '公司管理',
    'Company Profile': '公司信息',
    'User Account': '员工账号',
    'Company Basic Information': '公司基本信息',
    'Bank Account Information': '银行账户信息',
    'Invoice Information': '公司开票信息',
    'Company Detail Information': '公司详情信息',
    'Company Address Management': '公司地址管理',
    'Company Delivery Management': '公司配送管理',
    'Company License Management': '公司资质管理',
    'Category Qualification Information': '品种资质信息',
    'Account Management': '员工账号管理',
    'User Role Management': '员工角色管理',
    'Contract Management': '合同管理',
    'Contract Performance': '合同履约',
    'Certification': '品种资质信息',
  },
  en: {
    'Company Management': 'Company Management',
    'Company Profile': 'Company Profile',
    'User Account': 'User Account',
    'Company Basic Information': 'Company Basic Information',
    'Bank Account Information': 'Bank Account Information',
    'Invoice Information': 'Invoice Information',
    'Company Detail Information': 'Company Detail Information',
    'Company Address Management': 'Company Address Management',
    'Company Delivery Management': 'Company Delivery Management',
    'Category Qualification Information': 'Category Qualification Information',
    'Company License Management': 'Company License Management',
    'Account Management': 'Account Management',
    'User Role Management': 'User Role Management',
    'Contract Management': 'Contract Management',
    'Contract Performance': 'Contract Performance',
    'Certification': 'Certification'
  }
};